import React, { FC, useContext, useState } from 'react'
import ReactDOM from "react-dom"
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useParams } from "react-router-dom"
import { connect } from 'react-redux'
import { Button, Dropdown, Form, Label } from 'semantic-ui-react'
import { yupResolver } from '@hookform/resolvers/yup'

import * as GlobalType from "../../../contexts/GlobalType";
import { PreChekInStepEnum } from '../../../common/types/checkin'
import GlobalContext from '../../../contexts/GlobalContext'
import { RootDispatch, RootState } from '../../../store'
import InputSelect from '../../FormInputCustomer/InputSelect/InputSelectV2'
import { isMobile } from 'react-device-detect'
import Utility from '../../../Utility'
import InputText from '../../FormInputCustomer/InputText/InputTextV2'
import useFormFormatedList from '../../../hooks/useFormFormatedList'
import InputSelectDate from '../../FormInputCustomer/InputSelect/InputSelectDate'
import useRouter from '../../../hooks/useRouter'
import useFromSelfCheckin from '../../../hooks/useFromSelfCheckin'
import usePreCheckInSchema from '../../../hooks/usePreckInSchema'
import API, { ErrorManagement, ResponseManagement } from '../../../API'
import checkin, { handleCheckinData } from '../../../store/checkin';
import { toast } from 'react-toastify'
import { DevTool } from '@hookform/devtools';

import "./SecondaryInfos.css";

const mapProps = (state: RootState) => ({
  checkIn: state.checkin,
  isBookerHasMailOTA: state.authentication.isBookerHasMailOTA
})

const mapDispatch = (dispatch: RootDispatch) => ({
  handleCheckInData: dispatch.checkin.handleData,
  handleStepperForm: dispatch.checkin.handleStepperForm,
  loadBooking: dispatch.booking.load,
  updateBookingsCompletionRate: dispatch.booking.updateBookingsCompletionRateAsync,
  updateIsBookerPax: dispatch.booking.updateIsBookerPax,
  loadCheckIn: dispatch.checkin.load,
  loadAccommodations: dispatch.accommodation.loaded,
  handleModal: dispatch.modal.handleModal,
  handleAddPrecheckinAction: dispatch.common.handleAddPreCheckInAction,
  setAuthenticationInfos: dispatch.authentication.setAuthenticationInfos
})

type Props = ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

type FormValues = {
  civility : string
  telephone : string
  mobileCode : string
  mobile : string
  birthDate : string
  birthPlace : string
  firstAddress : string
  secondaryAddress : string
  thirdAddress : string
  zipCode : string
  city : string
  nationality : string
  language : string
  identityDocumentId : string
  identityDocument : string
}

const getLabel = (isMandatory, label) => {
    
  if(isMandatory === 'mandatory'){
    return { icon: { name:'asterisk', color : 'red', size : 'tiny', className : 'pl-2 float-right' }, content : label }
  }
  else{
    return {  content : label }
  }

}

const SecondaryInfos: FC<Props> = ({
  checkIn, handleCheckInData, handleStepperForm, updateBookingsCompletionRate, updateIsBookerPax, loadBooking, loadCheckIn, loadAccommodations, handleModal, handleAddPrecheckinAction, setAuthenticationInfos
}) => {

  // GlobalContext
  const [globalContext, dispatch] = useContext(GlobalContext) as any
  const [isLoading, setIsLoading] = useState(false)

  // Properties
  const { translations } = globalContext
  const fieldsForm = checkIn.checkInFieldParameters[checkIn.stepperForm.fieldCheckInType]
  const identity = checkIn.stepperForm.identity
  const checkInData = checkIn.theData?.[identity]
  let { token, lang, id } = useParams();

  // Hooks
  const location = useLocation();
  const fromSelfCheckin = useFromSelfCheckin(location);
  const { listIndicatifTel, languageSelect, listPaysSelect, identityDocumentTypeSelect } = useFormFormatedList(globalContext)

  // Schema validation
  //const schema = usePreCheckInSchema(fieldsForm, PreChekInStepEnum.SecondaryInfos);

  // useForm

  const methods = useForm<FormValues>({
          /*resolver: yupResolver(schema),*/
        });
  //const { isDirty } = formState;

  const goToPrincipalInfoStep = () => {
    
    // si il y a eu des modif sur le formulaire
    if( methods.formState.isDirty ){
      let dataToReturn = methods.getValues();
      handleCheckInData({
        [identity]: dataToReturn
      })
    }

    handleStepperForm({step: PreChekInStepEnum.PrincipalInfos});
  }

  const onSubmit = (formData: FormValues) => {

    const bookingFolderId = id
    const customerFile = Object.assign({}, checkInData, formData)

    //mauvais formattage quand Resident
    if (identity === "resident") {
      if (typeof customerFile.customerFileId === undefined) {
        customerFile.customerFileId = customerFile.id
      }
    }

    customerFile.roomingId = checkIn.selected.roomingListId
    // customerFile.customerId = customerFile.id

    const isNewMailFromSelfCheckin = fromSelfCheckin.isFromSelfCheckin && identity === 'resident' && customerFile.mail !== globalContext.user.mail;

    const dataToSend: any = {
      bookingId: checkIn.selected.bookingId,
      bookingFolderId: bookingFolderId,
      customerFile,
      isNewMailFromSelfCheckin
    };

    // a optimiser
    dataToSend.customerFile.identityDocumentId = parseInt(dataToSend.customerFile.identityDocumentId);
    delete (dataToSend.customerFile.bookingId);
    delete (dataToSend.customerFile.gdprAgreement);
    delete (dataToSend.customerFile.mailing);

    if (dataToSend.customerFile.customerFileId === undefined) {
      dataToSend.customerFile.customerFileId = 0;
    }
    if (dataToSend.customerFile.roomingId === undefined) {
      dataToSend.customerFile.roomingId = 0;
    }
    
    setIsLoading(true)

    API.postForm(Utility.getUrlAjax() + '/addPreCheckInAction', dataToSend )
    .then(res => {
      ResponseManagement(res,
        () => {
          const data = res.data.data
          const processedData = handleCheckinData(data);
          const currentIds = {
            bookingFolderId: bookingFolderId,
            bookingId: checkIn.selected.bookingId
          }
          //TODO utiliser store common
          handleAddPrecheckinAction({addPrechckinActionData: processedData, currentIds: currentIds})
            .then(() => {
              if (processedData.booker && processedData.customerFiles) {
                let bookerData = processedData.customerFiles.find(customerFile => parseInt(customerFile.id) === parseInt(processedData.booker));
                if (bookerData !== undefined) {
                  dispatch({ type: GlobalType.SET_USER, payload: bookerData });
                }
                if (data?.isMailValid) {
                  setAuthenticationInfos({isBookerHasMailOTA: !data.isMailValid})
                }
              }
            })
            .catch(err => console.log({err}))
            .finally(() => {
              if (data?.nonBlockingErrors?.length > 0) {
                data.nonBlockingErrors.forEach(errorCode => {
                  toast.warn(globalContext.translations[errorCode]);
                })
              }
              toast.success(globalContext.translations.modalCheckInAlertSuccessModal);
              handleModal({preCheckInModal: false})
            })


          // Maj booking completion rate
          // if (bookingsCompletionRates) {
          //   updateBookingsCompletionRate({
          //     bookingsCompletionRates: { bookingsCompletionRates },
          //     currentBookingId: dataToSend.bookingId,
          //     isFromSelfCheckin: fromSelfCheckin.isFromSelfCheckin
          //   });
          // }


          // loadBooking({
          //   bookings: processedData?.bookings ?? [],
          //   bookingsCompletionRates: bookingsCompletionRates ?? {},
          //   bookingFolder: processedData.bookingFolder,
          // });
          // loadAccommodations({
          //   accommodationServicesList: processedData.accommodationServices
          // })
          // loadCheckIn({
          //   checkInFieldParameters: processedData?.checkInFieldParameters ?? {},
          //   completionRates: data?.completionRates ?? {}
          // })
          // if (processedData?.isBookerPax) {
          //   updateIsBookerPax(processedData.isBookerPax);
          // }
          //


          // if (data?.nonBlockingErrors?.length > 0) {
          //   data.nonBlockingErrors.forEach(errorCode => {
          //     toast.warn(globalContext.translations[errorCode]);
          //   })
          // }
          // toast.success(globalContext.translations.modalCheckInAlertSuccessModal);
          // handleModal({preCheckInModal: false})
        },
        () => {
          if (res.data.message !== "") {
            if (typeof globalContext.translations[res.data.message] !== 'undefined') {
              toast.error(globalContext.translations[res.data.message])
            } else {
              toast.error(res.data.message)
            }
          } else {
            toast.error('Data sending error');
          }
        }
      );
    })
    .catch(error => {
      console.error(error);
      ErrorManagement(error, () => {
      }, globalContext.translations);
    })
    .finally(() => {
      setIsLoading(false)
    })
  
  }

  //console.log(globalContext.translations)

  const { control, formState } = methods
  const { errors } = formState

  return (
    <div>
      <Form onSubmit={methods.handleSubmit(onSubmit)}>
        <p>{globalContext.translations.modalCheckInFormPartTwoTitle} : </p>
        {fieldsForm.qualite !== 'deactivated' &&
          <Controller
            name='civility'
            control={control}
            defaultValue={checkInData?.civility ?? ''}
            render={({ field }) => (
              <InputSelect
                {...field}
                options={Utility.getListCivility(globalContext.translations)}
                onChange={(_, select) => field.onChange(select.value)}
                thelabel={translations.modalCheckInFormPartTwoCivility}
                //errorMessage={errors?.civility?.message}
                //required={fieldsForm.qualite === 'mandatory'}
                search={!isMobile}
                //placeholder={translations.modalCheckInFormPartTwoCivility}
              />
            )}
          />
          
        }
        {fieldsForm.tel !== 'deactivated' &&
          <Controller 
            name='telephone'
            control={control}
            defaultValue={checkInData?.telephone ?? ''}
            render={({ field }) => {
              // sending integer instead of string.
              return (
                <InputText
                  {...field} 
                  thelabel={globalContext.translations.modalCheckInFormPartTwoPhoneNumber}
                  //label={getLabel(fieldsForm.tel, globalContext.translations.modalCheckInFormPartTwoPhoneNumber)}
                  icon="phone"
                  iconPosition="left"
                  required={fieldsForm.tel === 'mandatory'}
                  //errorMessage={errors?.['telephone']?.message}
                />
              )
            }}
            
          />
        }
        {fieldsForm.mobile !== 'deactivated' &&
          
            <Form.Group>
              
              <Controller
                name='mobileCode'
                control={control}
                defaultValue={checkInData?.mobileCode ?? ''}
                render={({field}) => (
                  <InputSelect
                    {...field}
                    options={listIndicatifTel}
                    onChange={(_, select) => field.onChange(select.value) }
                    thelabel={globalContext.translations.modalCheckInFormPartTwoMobileNumber}
                    //required={fieldsForm.mobile === 'mandatory'}
                    //selection
                    //errorMessage={errors?.['mobileCode']?.message}
                    search={!isMobile}
                    
                    // placeholder={globalContext.translations.modalCheckInFormPartTwoMobileNumber}
                    //width={2}
                  />
                )}
              />
              <Controller 
                name='mobile'
                control={control}
                defaultValue={checkInData?.mobile ?? ''}
                render={({ field }) => {
                  // sending integer instead of string.
                  return (
                    <InputText
                      {...field} 
                      icon="phone"
                      iconPosition="left"
                      thelabel={globalContext.translations.modalCheckInFormPartTwoMobileNumber}
                      //label={getLabel(fieldsForm.mobile, globalContext.translations.modalCheckInFormPartTwoMobileNumber)}
                      required={fieldsForm.mobile === 'mandatory'}
                      //placeholder={globalContext.translations.modalCheckInFormPartTwoMobileNumber}
                      //errorMessage={errors?.['mobile']?.message}
                      width={14}
                    />
                  )
                }}
                
              />
            </Form.Group>
          
        }
        {fieldsForm.date_naissance !== 'deactivated' &&
          <Controller 
            name='birthDate'
            control={control}
            defaultValue={checkInData?.birthDate ?? ''}
            render={({field}) => (
              <InputSelectDate
                {...field} 
                label={globalContext.translations.modalCheckInFormPartTwoBrithdate}
                //value={field.value}
                handleChange={(_, value) => field.onChange(value)}
                //required={fieldsForm.date_naissance === 'mandatory'}
                search={!isMobile}
              />
            )}
          />
        }
        {fieldsForm.lieu_naissance !== 'deactivated' &&
          <Controller 
            name='birthPlace'
            control={control}
            defaultValue={checkInData?.birthPlace ?? ''}
            render={({ field }) => {
              // sending integer instead of string.
              return (
                <InputText
                  {...field} 
                  //label={getLabel(fieldsForm.lieu_naissance, globalContext.translations.modalCheckInFormPartTwoBirthPlace)}
                  thelabel={globalContext.translations.modalCheckInFormPartTwoBirthPlace}
                  placeholder={globalContext.translations.modalCheckInFormPartTwoBirthPlace}
                  required={fieldsForm.lieu_naissance === 'mandatory'}
                  //errorMessage={errors?.['birthPlace']?.message}
                />
              )
            }}
            
          />
        }
        {fieldsForm.ad1 !== 'deactivated' &&
          <>
            <Controller 
              name='firstAddress'
              control={control}
              defaultValue={checkInData?.firstAddress ?? ''}
              render={({ field }) => {
                // sending integer instead of string.
                return (
                  <InputText
                    {...field} 
                    //label={getLabel(fieldsForm.ad1, globalContext.translations.modalCheckInFormPartTwoAddress)}
                    thelabel={globalContext.translations.modalCheckInFormPartTwoAddress}
                    placeholder={globalContext.translations.modalCheckInFormPartTwoAddress}
                    required={fieldsForm.ad1 === 'mandatory'}
                    //errorMessage={errors?.['firstAddress']?.message}
                  />
                )
              }}
              
            />
            <Controller 
              name='secondaryAddress'
              control={control}
              defaultValue={checkInData?.secondaryAddress ?? ''}
              render={({ field }) => {
                // sending integer instead of string.
                return (
                  <InputText
                    {...field} 
                    thelabel={globalContext.translations.modalCheckInFormPartTwoSecondAddress}
                    placeholder={globalContext.translations.modalCheckInFormPartTwoSecondAddress}
                    //errorMessage={errors?.['secondaryAddress']?.message}
                  />
                )
              }}
            />
            <Controller 
              name='thirdAddress'
              control={control}
              defaultValue={checkInData?.thirdAddress ?? ''}
              render={({ field }) => {
                // sending integer instead of string.
                return (
                  <InputText
                    {...field} 
                    thelabel={globalContext.translations.modalCheckInFormPartTwoThirdAddress}
                    placeholder={globalContext.translations.modalCheckInFormPartTwoThirdAddress}
                    //errorMessage={errors?.['thirdAddress']?.message}
                  />
                )
              }}
            />
          </>
        }
        {fieldsForm.cp !== 'deactivated' &&
          <Controller 
            name='zipCode'
            control={control}
            defaultValue={checkInData?.zipCode ?? ''}
            render={({ field }) => {
              // sending integer instead of string.
              return (
                <InputText
                  {...field}
                  thelabel={globalContext.translations.modalCheckInFormPartTwoPostalCode}
                  placeholder={globalContext.translations.modalCheckInFormPartTwoPostalCode}
                  required={fieldsForm.cp === 'mandatory'}
                  //errorMessage={errors?.['zipCode']?.message}
                />
              )
            }}
            
          />
        }
        {fieldsForm.ville !== 'deactivated' &&
          <Controller 
            name='city'
            control={control}
            defaultValue={checkInData?.city ?? ''}
            render={({ field }) => {
              // sending integer instead of string.
              return (
                <InputText
                  {...field}
                  thelabel={globalContext.translations.modalCheckInFormPartTwoCity}
                  placeholder={globalContext.translations.modalCheckInFormPartTwoCity}
                  required={fieldsForm.ville === 'mandatory'}
                  //errorMessage={errors?.['city']?.message}
                  //value={checkInData?.city ?? ''}
                />
              )
            }}
            
          />
        }
        {fieldsForm.nationalite !== 'deactivated' &&
          <Controller 
            name='nationality'
            control={control}
            defaultValue={checkInData?.nationality ?? ''}
            render={({field}) => (
              <InputSelect
                {...field} 
                options={listPaysSelect}
                onChange={(_, select) => field.onChange(select.value)}
                //errorMessage={errors?.['nationality']?.message}
                thelabel={translations.modalCheckInFormPartTwoSelectNationality}
                //required={fieldsForm.nationalite === 'mandatory'}
                search={!isMobile}
              />
            )}
          />
          
        }
        {fieldsForm.id_langue_fich_client !== 'deactivated' &&
          <Controller
            name='language'
            control={control}
            defaultValue={checkInData?.language ?? ''}
            render={({field}) => (
              <InputSelect
                {...field} 
                options={languageSelect}
                onChange={(_, select) => field.onChange(select.value)}
                //errorMessage={errors?.['language']?.message}
                thelabel={translations.modalCheckInFormPartTwoLanguage}
                //required={fieldsForm.id_langue_fich_client === 'mandatory'}
                search={!isMobile}
              />
            )}
          />
          
        }
        {fieldsForm.id_type_piece_identite !== 'deactivated' &&
          <>
            <Controller 
              name='identityDocumentId'
              control={control}
              defaultValue={checkInData?.identityDocumentId ?? ''}
              render={({field}) => (
                <InputSelect
                  {...field} 
                  options={identityDocumentTypeSelect}
                  onChange={(_, select) => field.onChange(select.value)}
                  //errorMessage={errors?.['identityDocumentId']?.message}
                  thelabel={translations.modalCheckInFormPartTwoIdentityDocumentType}
                  //required={fieldsForm.id_type_piece_identite === 'mandatory'}
                  search={!isMobile}
                />
              )}
            />
            <Controller 
              name='identityDocument' 
              control={control} 
              defaultValue={checkInData?.identityDocument ?? ''}
              render={({ field }) => {
                // sending integer instead of string.
                return (
                  <InputText
                    {...field}
                    thelabel={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentNumber}
                    placeholder={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentNumber}
                    required={fieldsForm.id_type_piece_identite === 'mandatory'}
                    //errorMessage={errors?.['identityDocument']?.message}
                  />
                )
              }}
              
            />
          </>
        }
        <div className='ui mt-4 right aligned container'>
          <p style={{ textAlign: 'center', color: 'red' }}>{globalContext.translations.modalCheckInFormPartTwoMessageMandatory}</p>
          <Button
            onClick={ goToPrincipalInfoStep }
            name='precedent'
            primary
            content={"precedent"/*translations.modalCheckInNextStep*/}
            icon="chevron left"
            labelPosition="left"
          />
          <Button
            type="submit"
            loading={isLoading}
            disabled={isLoading}
            primary
            content={translations.modalCheckInBtnSubmit}
            icon="chevron right"
            labelPosition="right"
          />
          
        </div>
      </Form>
      <DevTool control={control} />
    </div>
  )
}

export default connect(mapProps, mapDispatch)(SecondaryInfos)